import request from "@/utils/request";

// 分页查询消息
export const pageWorkMessage = (params) =>
  request({
    url: "/api/message/workMessage/page",
    method: "get",
    params,
  });

// 分页查询登陆用户消息
export const pageWorkMessageWithCurrentUser = (params) =>
  request({
    url: "/api/message/workMessage/pageWithCurrentUser",
    method: "get",
    params,
  });

// 查询消息详情
export const detailWorkMessage = (id) =>
  request({
    url: `/api/message/workMessage/${id}`,
    method: "get",
  });

// 批量已读
export const batchReadWorkMessage = (ids) =>
  request({
    url: `/api/message/workMessage/read/batch`,
    method: "post",
    data: ids,
  });

// 全部已读
export const allReadWorkMessage = () =>
  request({
    url: `/api/message/workMessage/read/all`,
    method: "post",
  });
